<template>
  <button @click.prevent="onClicked" class="btn btn-default">
    <span v-if="icon"><i :class="['fas', icon]"></i>&nbsp;</span><slot />
  </button>
</template>

<script>
export default {
  name: 'ProgressTrackerButton',
  props: {
    icon: String
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>